import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';
import { ButtonModule } from '@fino-ui/button';
import { BaseModalComponent } from '@fino-ui/modal';
import { TranslationModule } from '@fino-ui/translation';
import downloadJs from 'downloadjs';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';

@Component({
  selector: 'app-letter-upload',
  templateUrl: './letter-upload.component.html',
  styleUrl: './letter-upload.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslationModule, ButtonModule, PdfJsViewerModule],
})
export class LetterUploadComponent
  extends BaseModalComponent<{ pdfPreview: string }, string>
  implements OnInit
{
  constructor() {
    super();
    Object.assign(this, this.data ?? {});
  }

  pdfPreviewAsBase64: Uint8Array;
  pdfPreview: string;

  ngOnInit(): void {
    this.pdfPreviewAsBase64 = this.convertDataURIToBinary(this.pdfPreview);
  }

  download() {
    downloadJs(
      `data:application/pdf;base64,${this.pdfPreview}`,
      'briefvorlage.pdf',
      'application/pdf',
    );
  }

  convertDataURIToBinary(dataURI) {
    const raw = window.atob(dataURI);
    const rawLength = raw.length;
    const array = new Uint8Array(new ArrayBuffer(rawLength));

    for (let i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }

  abort() {
    this.close();
  }

  submit() {
    this.result = this.pdfPreview;
    this.close();
  }
}
